import { Component, OnInit } from '@angular/core';
import { IdentityProvider } from '@app/core/providers/identity/identity-provider';
import { AuthGuard } from "@app/core/guards";
import {environment} from '../../../../environments';

// @ts-ignore
const data = require('../../../../../package.json');

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {

  constructor(private readonly identity: IdentityProvider, private readonly authGuard: AuthGuard) { }

  showBuildNumbers: boolean = environment.showBuildNumbers;
  buildNumber: string = data.version;
  currentYear = new Date().getFullYear();
  contactUsNumber: string;

  ngOnInit() {
    this.authGuard.loadContactUsIfAvailable().subscribe(isAuthenticated => {
      if (isAuthenticated) {
        if (typeof this?.identity?.isContactUsListSet?.subscribe === 'function') {
          this.identity.isContactUsListSet.subscribe(isContactUsList => {
            if (
              isContactUsList && this.identity?.contactUsList?.retailContactUsList &&
              this.identity?.contactUsList?.retailContactUsList.length > 0
            ) {
              this.contactUsNumber = this.identity?.contactUsList?.retailContactUsList[0].phoneNumber;
            }
          });
        }
      }
    });

  }

  isLoggedIn(): boolean {
    return this.identity.currentUser.isAuthenticated;
  }
}
